import { ActiveStateStrategy, NavigationItemBase } from "@/domains/navigation/navigation-item"

import type { Location } from "../navigation-item"

export class ActiveStateStartsWithStrategy implements ActiveStateStrategy {
  private startsWith: string

  constructor(startsWith: string) {
    this.startsWith = startsWith
  }

  isActive(location: Location, item: NavigationItemBase): boolean {
    return location.pathname.startsWith(this.startsWith)
  }
}
